module.exports = __webpack_public_path__ + "fonts/bahnschrift.f7226ba5.ttf";